module.exports = __webpack_public_path__ + "static/img/格物智安工地安全管理平台操作说明-2.40ea01d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentation/格物智安工地安全管理平台操作说明-2.jpg
// module id = FPus
// module chunks = 0